/**
 * Sentry instrumentation for the admin app — must be imported before all other modules.
 *
 * Provides error tracking, performance tracing (with React Router awareness), and log capture.
 */

import * as Sentry from '@sentry/react';
import { useEffect } from 'react';
import {
  useLocation,
  useNavigationType,
  createRoutesFromChildren,
  matchRoutes,
} from 'react-router-dom';

const isProd = import.meta.env.MODE === 'production';

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  environment: import.meta.env.MODE,

  integrations: [
    Sentry.reactRouterV6BrowserTracingIntegration({
      useEffect,
      useLocation,
      useNavigationType,
      createRoutesFromChildren,
      matchRoutes,
    }),
    // Capture errors only — capturing every console.log shipped serialized
    // payloads on every render and was a top contributor to long tasks in
    // production (interactions stalled at >1s INP).
    Sentry.consoleLoggingIntegration({ levels: ['error'] }),
  ],

  // Sample a small fraction of transactions in prod to keep Sentry's
  // instrumentation off the critical path. Full sampling stays in dev.
  tracesSampleRate: isProd ? 0.05 : 1.0,
  enableLogs: false,
});
